var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "md-column" } },
    [
      _vm.videos && _vm.videos.length > 0
        ? _c("md-layout", { attrs: { "md-column": "md-column" } }, [
            _c(
              "div",
              { staticClass: "md-subheading" },
              [
                _vm._v(_vm._s(_vm.label)),
                _c("div", { staticClass: "titleLine styleRow" }, [
                  _c("p", { staticClass: "rowElements" }),
                  _c("p", { staticClass: "rowElements" }, [_vm._v("Name")]),
                  _c("p", { staticClass: "rowElements" }, [_vm._v("Advisor")]),
                  _c("p", { staticClass: "rowElements" }, [_vm._v("Category")]),
                  _c("p", { staticClass: "rowElements" }, [_vm._v("Duration")]),
                  _c("p", { staticClass: "rowElements" }, [_vm._v("Provider")]),
                  _c("p", { staticClass: "rowElements" }, [_vm._v("Updated")]),
                  _vm.allowDelete
                    ? _c("p", { staticClass: "rowElements" })
                    : _vm._e()
                ]),
                _vm._l(_vm.videos, function(item, index) {
                  return _c(
                    "div",
                    { key: item._id, staticClass: "styleRow rowVideos" },
                    [
                      _c(
                        "div",
                        { staticClass: "rowElements" },
                        [
                          _c("md-avatar", [
                            _c("img", {
                              attrs: {
                                src: _vm.getVideoPoster(item),
                                alt: item.name
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _c("div", { staticClass: "rowElements" }, [
                        _vm._v(_vm._s(item.name))
                      ]),
                      _c("div", { staticClass: "rowElements overflow" }, [
                        _vm._v(_vm._s(_vm.advisor(item)))
                      ]),
                      _c("div", { staticClass: "rowElements overflow" }, [
                        _vm._v(_vm._s(item.categories[0]))
                      ]),
                      _c("div", { staticClass: "rowElements" }, [
                        _vm._v(_vm._s(_vm.secondsToHms(item.duration)))
                      ]),
                      _c("div", { staticClass: "rowElements" }, [
                        _vm._v(_vm._s(item.credit))
                      ]),
                      _c("div", { staticClass: "rowElements" }, [
                        _vm._v(
                          _vm._s(_vm._f("moment")(item.lastUpdated, "from"))
                        )
                      ]),
                      _vm.allowDelete
                        ? _c(
                            "div",
                            { staticClass: "rowElements" },
                            [
                              _vm.deletingItem === index
                                ? _c("md-spinner", {
                                    staticClass: "md-accent",
                                    attrs: {
                                      "md-indeterminate": "md-indeterminate",
                                      "md-size": 25
                                    }
                                  })
                                : _c(
                                    "md-button",
                                    {
                                      staticClass: "md-icon-button md-warn btn",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeItem(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("md-icon", {
                                        staticClass: "icon",
                                        attrs: {
                                          "md-iconset": "fa fa-trash-alt"
                                        }
                                      })
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                })
              ],
              2
            )
          ])
        : _c(
            "md-layout",
            { attrs: { id: "no-results", "md-align": "center" } },
            [
              _c(
                "span",
                { staticClass: "md-subheading" },
                [
                  _c("md-icon", {
                    staticClass: "md-accent on-left",
                    attrs: { "md-iconset": "fa fa-exclamation-circle" }
                  }),
                  _vm._v("This playlist has no videos")
                ],
                1
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aefc8e2c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefc8e2c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/playlist/PlaylistContentTable.vue
// module id = 726
// module chunks = 0